const colorVariableRegex = /--(text|custom)-color.*?(?=(?:\)))/g;

const getElementCustomColorVariables = (element) =>
  element.innerHTML.match(colorVariableRegex) || [];

export default getElementCustomColorVariables;
